import { mergeStyles } from '#src/hooks/use-merged-styles.js';

import localStyles from './Card.scss';

export function Card({ description, title, image, classNames }) {
  const url = image?.fields?.file?.url;
  const styles = mergeStyles(localStyles, classNames);

  return (
    <div className={styles.container}>
      <img className={styles.image} src={url} alt={title} />
      {(title || description) && (
        <div className={styles.content}>
          {title && <h4 className={styles.title}>{title}</h4>}
          {description && <p className={styles.description}>{description}</p>}
        </div>
      )}
    </div>
  );
}
